import { defineStore } from 'pinia'
import { ref } from 'vue'

// 確認モーダルの共通ストア
export const useConfirmModalStore = defineStore('confirmModal', () => {
  const visible = ref(false)
  const title = ref('確認')
  const message = ref<string | string[]>('')
  const cancelText = ref('キャンセル')
  const confirmText = ref('OK')
  // 呼び出し元にアクションを通知するためのハンドラ
  let resolver: ((confirmed: boolean) => void) | null = null

  function open(
    opts: {
      title?: string
      message?: string | string[]
      cancelText?: string
      confirmText?: string
    } = {},
  ) {
    title.value = opts.title ?? title.value
    message.value = opts.message ?? message.value
    cancelText.value = opts.cancelText ?? cancelText.value
    confirmText.value = opts.confirmText ?? confirmText.value
    visible.value = true
    return new Promise<boolean>((resolve) => {
      resolver = resolve
    })
  }

  function close() {
    visible.value = false
    resolver = null
  }

  function confirm() {
    visible.value = false
    resolver?.(true)
    resolver = null
  }

  function cancel() {
    visible.value = false
    resolver?.(false)
    resolver = null
  }

  return { visible, title, message, cancelText, confirmText, open, close, confirm, cancel }
})
